import React, {useEffect, useRef, useState} from 'react';
import {Tooltip} from 'react-tooltip';
import {useTranslation} from '../../../../hooks/useTranslation';

import {FIELD_PICKER_DATA} from './const';

import './index.scss';
import 'react-tooltip/dist/react-tooltip.css';
import {useDispatch, useSelector} from 'react-redux';
import {setFieldsId, setFieldType} from '../../service/createForm.slice';
import {OtherFields} from '../index';
import {OtherFieldsIcon} from '../../icons';
import {useDropdownPosition} from '../../model';
import {
  CHECKBOX_FIELD,
  CLEANING_STATUS_FIELD,
  CONDITION_CODE_FIELD,
  IMAGE_FIELD,
  INPUT_FIELD,
  MICROLAB_TEST_RESULT_FIELD,
  NUMERIC_FIELD,
  RADIO_FIELD,
  SELECT_FIELD,
  SUMP_SAMPLE_FIELD,
  SUMP_SAMPLE_WITH_NA_FIELD,
  TANK_CONDITION_FIELD,
  TEXT_FIELD,
} from '../../fields/staticData';

const picked_type = (type, t) => {
  switch (type) {
    case 'text':
      return INPUT_FIELD;
    case 'radio':
      return RADIO_FIELD;
    case 'condition_code':
      return CONDITION_CODE_FIELD(t);
    case 'numeric':
      return NUMERIC_FIELD;
    case 'multiple_photo':
      return IMAGE_FIELD;
    case 'textarea':
      return TEXT_FIELD;
    case 'checkbox':
      return CHECKBOX_FIELD;
    case 'select':
      return SELECT_FIELD;
    case 'sump_sample':
      return SUMP_SAMPLE_FIELD(t);
    case 'sump_sample_optional':
      return SUMP_SAMPLE_WITH_NA_FIELD(t);
    case 'tank_condition':
      return TANK_CONDITION_FIELD(t);
    case 'cleaning_status':
      return CLEANING_STATUS_FIELD(t);
    case 'microlab_test_result':
      return MICROLAB_TEST_RESULT_FIELD(t);
    default:
      return INPUT_FIELD;
  }
};

function FieldPicker() {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const sidebarRef = useRef(null);

  const active_field_idx = useSelector(
    state => state.rootReducer.createFormSlice.active_field,
  );
  const fields = useSelector(
    state => state.rootReducer.createFormSlice.data.fields,
  );

  const dropdownPosition = useDropdownPosition(
    dropdownRef,
    sidebarRef,
    isDropdownOpen,
  );

  const handleChangeType = type => {
    if (fields.length) {
      if (fields[active_field_idx].field_type !== type) {
        dispatch(
          setFieldType({
            idx: active_field_idx,
            field: picked_type(type, t),
          }),
        );
      }
      dispatch(setFieldsId());
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className='field-picker' ref={sidebarRef}>
      {FIELD_PICKER_DATA?.map(
        ({icon: Icon, type, tooltip, field_type}, idx) => (
          <div key={idx} onClick={() => handleChangeType(field_type)}>
            <div
              className='field-picker__item'
              data-tooltip-id={`${type}-id`}
              data-tooltip-content={t(`createNewForm.components.fieldTypes.${tooltip}`)}
            >
              <Icon />
            </div>
            <Tooltip id={`${type}-id`} place='right-start' />
          </div>
        ),
      )}
      <div onClick={toggleDropdown}>
        <div
          className='field-picker__item'
          data-tooltip-id={`other-fields-id`}
          data-tooltip-content={t('createNewForm.components.otherFields')}
        >
          <OtherFieldsIcon />
        </div>
        <Tooltip id={`other-fields-id`} place='right-start' />
      </div>
      {isDropdownOpen ? (
        <OtherFields
          toggleDropdown={toggleDropdown}
          handleChangeType={handleChangeType}
          dropdownRef={dropdownRef}
          dropdownPosition={dropdownPosition}
        />
      ) : null}
    </div>
  );
}

export default FieldPicker;
